import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=bc10222e&scoped=true&"
import script from "./MediaItem.vue?vue&type=script&lang=ts&"
export * from "./MediaItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaItem.vue?vue&type=style&index=0&id=bc10222e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc10222e",
  null
  
)

export default component.exports